if (!customElements.get('ns-classic-moments')) {
  customElements.define('ns-classic-moments', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.rail = this.querySelector('.ns-classic-moments__rail');
      this.cards = [...this.querySelectorAll('.ns-classic-moment')];
      if (!this.rail || !this.cards.length) return;
      this.index = 0;
      this.positions = () => this.cards.map(card => card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left + this.rail.scrollLeft);
      const paint = () => {
        const positions = this.positions();
        this.index = positions.reduce((best, left, i) => Math.abs(left - this.rail.scrollLeft) < Math.abs(positions[best] - this.rail.scrollLeft) ? i : best, 0);

      };
      const go = index => {
        const bounded = Math.max(0, Math.min(this.cards.length - 1, index));
        this.rail.scrollTo({ left: this.positions()[bounded], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.rail.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.rail.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; paint(); });
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => {
        this.rail.style.setProperty('--ns-moments-end', `${Math.max(0, this.rail.clientWidth - this.cards[this.cards.length - 1].getBoundingClientRect().width)}px`);
        paint();
      });
      this.resize.observe(this.rail);
      paint();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.abort = null;
    }
  });
}
